import styled from "styled-components";

export const TermsBlockStyle = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--glz-color-neutral-tone-1);
  padding-bottom: 90px;
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    font-size: 16px;
    border-bottom: none;
    padding-bottom: 48px;
  }
`;

export const TermsItemStyle = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  max-width: 350px;
  flex-grow: 1;
  @media (max-width: 900px) {
    padding-bottom: 40px;
  }
`;

export const TermsTitle = styled.div`
  color: var(--glz-color-neutral-tone-5);
  font-size: 18px;
  line-height: 26px;
  padding-top: 20px;

  @media (max-width: 900px) {
    font-size: 16px;
  }
`;

type TermsImageType = {
  width: number | undefined
  widthMobile: number | undefined
  height: number | undefined
  heightMobile: number | undefined
}

export const TermsImage = styled.img<TermsImageType>`
  width: ${(props) => (props.width ? `${props.width}px` : "75px")};
  height: ${(props) => (props.height ? `${props.height}px` : "75px")};
  @media (max-width: 900px) {
    width: ${(props) => (props.widthMobile ? `${props.widthMobile}px` : "64px")};
    height: ${(props) => (props.heightMobile ? `${props.heightMobile}px` : "64px")};
  }
`;
